import axios from "axios";
//const API_URL = "https://md-booking.hmc.co.il/api";
// Stoplight
//const API_URL = "http://127.0.0.1:3100";
//Postman
//const API_URL = "https://b9e8ec4c-1888-446e-a704-971642eefa03.mock.pstmn.io";
const API_URL =
  "https://cors-anywhere.herokuapp.com/https://md-booking.hmc.co.il/api/external";
//const API_LIVE = "https://md-booking.hmc.co.il/api/external";
const TOKEN = "kTr00Wmjlsl6oRt89927M4o0S1r5ENG7uc";
//const TOKEN = "3bY9QkzjxORvUJUfLk0pPjX7AGWxOdm4T7mKwYva";
const authDemo = {
  username: "demo",
  name: "מקסים",
  pass: "demo",
  authSMS: "1111"
};
const userDemo = {
  user_id: 1,
  name: "מקסים",
  phone_number: "052****463",
  doctors: [
    {
      doctor_id: 222,
      name: "רופא 1"
    },
    {
      doctor_id: 33,
      name: "רופא 2"
    }
  ]
};
var eventsDemo = [];
var year = 2020;
var month = 10;
var day = 1;
var hourFrom = Math.floor(Math.random() * 20 + 7); // returns a random integer from 1 to 10
var hourTo = hourFrom + 4;
for (let i = 0; i < 100; i++) {
  let dataStart = new Date(year, month, day, hourFrom);
  let dataEnd = new Date(year, month, day, hourTo);
  let appointmentStart = new Date(year, month, day, hourFrom + 1, 0);
  let appointmentEnd = new Date(year, month, day, hourFrom + 1, 30);
  let tmp = {
    start: dataStart,
    end: dataEnd,
    resourceId: "appointment",
    backgroundColor: "#ff6700",
    id: "availableAppointmentBlocks",
    background_block_id: i + Math.random() * 999999 + 2,
    background_block_type: "appointment",
    title: "בלוק",
    overlap: true,
    rendering: "background",
    has_events: "yes"
  };

  for (let j = 0; j < 5; j++) {
    let appointment = {
      start: new Date(year, month, day, hourFrom + j, 0),
      end: new Date(year, month, day, hourFrom + j, 30),
      resourceId: "appointment",
      backgroundColor: "#ff6700",
      id: "availableAppointmentBlocks",
      background_block_id: i + Math.random() + 2,
      background_block_type: "appointment",
      title: "תור",
      overlap: true,
      content:
        "שם המטופל 012345678 | מכבי שלי זהב 054-333333 | באישור נעמה אמא של...."
    };
    eventsDemo.push(appointment);
  }
  eventsDemo.push(tmp);

  hourFrom = Math.floor(Math.random() * 18) + 7; // returns a random integer from 1 to 10
  hourTo = hourFrom + 4;
  day++;
  if (day == 31) {
    day = 1;
    month++;
  }
  if (month === 12) {
    month = 0;
    year++;
  }
}
var savedAppointments = [];
export default class API {
  API = axios.create({
    baseURL: API_URL
    /*
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/x-www-form-urlencoded"
    }

     */
  });
  constructor() {}
  getToken() {
    return new Promise((resolve, reject) => {
      this.API.get("/login").then(({ data }) => {
        resolve(data);
      });
    });
  }
  login(username, password) {
    return new Promise((resolve, reject) => {
      if (authDemo.username == username && authDemo.pass == password) {
        resolve(userDemo);
      }
      // this.API.post("/login", {
      //   token: TOKEN,
      //   username: username,
      //   password: password
      // })
      //   .then(res => {
      //     if (res.status == 200) {
      //       resolve(res.data);
      //     }
      //     resolve(false);
      //   })
      //   .catch(reject);
    });
  }
  sendSMS(user_id) {
    this.API.post("/send_sms", {
      user_id: user_id
    });
  }
  validateSMS(sms) {
    return new Promise((resolve, reject) => {
      if (authDemo.authSMS == sms) {
        resolve(userDemo);
      }
      // this.API({
      //   method: "POST",
      //   url: "/login_validate",
      //   data: {
      //     _toke: TOKEN,
      //     sms: sms
      //   }
      // })
      //   .then(res => {
      //     if (res.status == 200) {
      //       resolve(res.data);
      //     }
      //     resolve(false);
      //   })
      //   .catch(reject);
    });
  }
  getBlockTypes(doctor_id, block_type) {
    return new Promise((resolve, reject) => {
      let dates = {
        dates: [
          "01/06/2020",
          "01/06/2020",
          "01/06/2020",
          "23/06/2020",
          "23/06/2020",
          "23/06/2020",
          "24/06/2020",
          "24/06/2020",
          "28/06/2020",
          "28/06/2020",
          "29/06/2020",
          "29/06/2020",
          "29/05/2020",
          "27/05/2020",
          "25/05/2020",
          "22/05/2020",
          "19/05/2020",
          "19/05/2020",
          "17/05/2020"
        ],
        "2020-06-01": "12:50",
        "2020-06-23": "15:50",
        "2020-06-24": "10:50",
        "2020-06-28": "09:50",
        "2020-06-29": "10:50",
        "2020-05-29": "08:50",
        "2020-05-27": "10:50",
        "2020-05-25": "11:50",
        "2020-05-22": "10:45",
        "2020-05-19": "13:00",
        "2020-05-17": "13:50"
      };
      resolve(dates);
      let dataArr = new FormData();
      dataArr.append("token", TOKEN);
      dataArr.append("doctor_id", doctor_id);
      dataArr.append("block_type", block_type);

      this.API({
        method: "post",
        url: "/get-block-type-dates",
        data: {
          token: TOKEN,
          doctor_id: doctor_id,
          block_type: block_type
        }
      })
        .then(res => {
          resolve(res);
        })
        .catch(reject);
    });
  }
  getBlockTypeDates(doctor_id, block_type) {
    return new Promise((resolve, reject) => {
      let dates = {
        dates: [
          "01/11/2020",
          "02/11/2020",
          "03/11/2020",
          "23/11/2020",
          "23/11/2020",
          "23/11/2020",
          "24/11/2020",
          "24/11/2020",
          "28/11/2020",
          "28/11/2020",
          "29/11/2020",
          "29/11/2020",
          "29/12/2020",
          "27/12/2020",
          "25/12/2020",
          "22/12/2020",
          "19/12/2020",
          "19/12/2020",
          "17/12/2020"
        ],
        "2020-11-01": ["12:50", "13:10", "13:30", "14:00"],
        "2020-11-23": ["12:50", "13:10", "13:30", "14:00"],
        "2020-11-24": ["12:50", "13:10", "13:30", "14:00"],
        "2020-11-28": ["12:50", "13:10", "13:30", "14:00"],
        "2020-11-29": ["12:50", "13:10", "13:30", "14:00"],
        "2020-12-29": ["12:50", "13:10", "13:30", "14:00"],
        "2020-12-27": ["12:50", "13:10", "13:30", "14:00"],
        "2020-12-25": ["12:50", "13:10", "13:30", "14:00"],
        "2020-12-22": ["12:50", "13:10", "13:30", "14:00"],
        "2020-12-19": ["12:50", "13:10", "13:30", "14:00"],
        "2020-12-17": ["12:50", "13:10", "13:30", "14:00"]
      };
      resolve(dates);
      // this.API.post("/get_block_type_dates", {
      //   token: TOKEN,
      //   doctor_id: doctor_id,
      //   block_type: block_type
      // }).then(res => {
      //   //console.log(res);
      //   resolve(res.data);
      // });
    });
  }
  getFullCalendarEvents(doctor_id, startDate, endDate) {
    /*
    token: I6Q1xPP3n5K8jhqsGSlvaFF3El1redQIjhE1ZsUY
    view_type: modal
    doctor_id: 2576
    event_type: surgery_catheterization_gastro_appointment
    start: 2020-05-17T00:00:00
    end: 2020-05-23T00:00:00
     */

    return new Promise((resolve, reject) => {
      resolve(eventsDemo);
      // let formData = new FormData();
      // formData.append("token", TOKEN);
      // formData.append("user_id", 2940);
      // //formData.append("doctor_id", 10);
      // //formData.append("event_type", "appointment");
      // formData.append("event_type", "surgery");
      // this.API({
      //   method: "post",
      //   url: "/fullcalendar_events_ajax",
      //   data: formData
      // }).then(res => {
      //   resolve(res.data);
      // });
    });
  }
  getAppointmentInfo(appointment_id) {
    return new Promise((resolve, reject) => {
      this.API.post("/appointment_info", {
        appointment_id: 161933,
        token: TOKEN
      }).then(res => {
        //console.log(res);
        resolve(res.data);
      });
    });
  }
  getSurgeryInfo(surgery_id) {
    return new Promise((resolve, reject) => {
      this.API.post("/surgery_info", {
        surgery_id: 67031,
        token: TOKEN
      }).then(res => {
        //console.log(res);
        resolve(res.data);
      });
    });
  }
  getSurgeries(doctor_license) {
    return new Promise((resolve, reject) => {
      this.API.post("/surgeries", {
        surgery_id: 67031,
        token: TOKEN
      }).then(res => {
        //console.log(res);
        resolve(res.data);
      });
    });
  }
  saveAppointment(appointment) {
    return new Promise((resolve, reject) => {
      savedAppointments.push(appointment);
      resolve(true);
      // this.API.post("/save-appointment-agenda", {
      //   appointments: appointment
      // }).then(res => {
      //   //console.log(res);
      //   resolve(res.data);
      // });
    });
  }
  appointmentApprove(value, appointment_id) {
    return new Promise((resolve, reject) => {
      this.API.post("/appointment-xeditable", {
        token: TOKEN,
        name: "arrival_status",
        value: value,
        pk: appointment_id
      }).then(res => {
        //console.log(res);
        resolve(res.data);
      });
    });
  }
  getAppointmentById(id, doctor_id) {
    return new Promise((resolve, reject) => {
      this.API.post("/search_id", {
        token: TOKEN,
        doctor_id: doctor_id,
        id: id
      }).then(res => {
        //console.log(res);
        resolve(res.data);
      });
    });
  }
  cancelAppointment(appoitment_id) {
    return new Promise((resolve, reject) => {
      this.API({
        mehtod: "post",
        url: "/save-appointment-agenda",
        data: {
          token: TOKEN,
          appointments: doctor_id,
          view_type: "modal",
          event_type: "surgery_catheterization_gastro_appointment",
          start: startDate,
          end: endDate
        }
      });
      resolve(json);
    });
  }
  getBlockTypes() {
    return new Promise((resolve, reject) => {
      this.API.get("/get_block_types").then(res => {
        // console.log(res);
        resolve(res.data);
      });
    });
  }
  checkPassport(id, license) {
    return new Promise((resolve, reject) => {
      this.API.post("passport-cheker", {
        token: TOKEN,
        license: license,
        passport: id
      }).then(res => {
        resolve(res.data);
      });
    });
  }
  getTypehead(type) {
    /*
    Types :
    material_sensitivity
    medication_sensitivity
    current_diagnosis
    past_diagnosis
    past_surgery
    current_surgery_category תחום
    current_surgery שם קוד ניתוח
    current_procedure שם קוד פרוצדורה
    insurance_surgery_category
    insurance_surgery
     */
    return new Promise((resolve, reject) => {
      this.API.post("typehead", { type: type }).then(res => {
        if (res.data) {
          resolve(res.data);
        }
      });
    });
  }
  validatePassport(passport, insurance) {
    return new Promise((resolve, reject) => {
      resolve(userDemo);
      this.API.post("passport-checker", {
        token: TOKEN,
        passport: passport,
        license: 11115
        //insurance: insurance
      }).then(res => {
        if (res.status == 200) {
          resolve(res.data);
        }
      });
    });
  }
}
